import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfAuthorBasicInfo } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfAuthorBasicInfo';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfAuthorSocial } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: ExploreContentResponsePageAllOfThreeContentItemContentOneOfAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfAuthorSocial;
};
